import { Typography } from '@breetometer/components';
import { Amount } from 'BreetComponents';
import { type CURRENCYCODETYPE, CURRENCYCONFIG, getSafeObjectField } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { IWithdrawalsProps } from '../DialogWithdrawalHistoryDetails.helpers';
import WithdrawalsAddress from './Withdrawals.Address';
import WithdrawalsNuban from './Withdrawals.Nuban';

const Withdrawals = ({ withdrawalHistoryData }: IWithdrawalsProps) => {
	const currencyOutput = useCurrencyOutput();

	const fiatConfig = getSafeObjectField(
		CURRENCYCONFIG,
		withdrawalHistoryData.currency.toUpperCase() as CURRENCYCODETYPE,
		CURRENCYCONFIG.USD
	);

	const isNuban = withdrawalHistoryData.doc.meta.type === 'nuban' || withdrawalHistoryData.doc.meta.type === 'ghs_bank';

	return (
		<>
			<div className='transactiondetails_header'>
				<Typography as='p'>WITHDRAWAL</Typography>
				<Typography as='h5'>
					{fiatConfig.symbol}
					<Amount>{currencyOutput(isNuban ? withdrawalHistoryData.doc.payoutAmount : withdrawalHistoryData.amount)}</Amount>
				</Typography>
			</div>

			{isNuban ? (
				<WithdrawalsNuban withdrawalHistoryData={withdrawalHistoryData} />
			) : (
				<WithdrawalsAddress withdrawalHistoryData={withdrawalHistoryData} />
			)}
		</>
	);
};

export default Withdrawals;
